import { gql } from "@apollo/client";

// --- Create Membership ---
export const CREATE_MEMBERSHIP = gql`
  mutation createMembership($input: createMembershipInput) {
    createMembership(input: $input) {
      membershipId
      name
      industry
      email
      primaryContact
      secondaryContact
      services
      status
      location
      orgId
      primaryName
      secondaryName
      website
      PAN
      GST
      TIN
      TAN
      AlternateEmail
      logo
      membershipValidityFrom
      membershipValidityTo
      createdAt
    }
  }
`;

// --- Update Membership ---


// --- Delete Membership by ID ---


// --- Get all Memberships ---


// --- Get Memberships by Org ---


// --- Get Membership by ID ---

